import { createSelector } from 'reselect';

import { getCurrentTabState } from '../tabs';

export const getOfferType = createSelector(getCurrentTabState, tabState => {
  return tabState.filters.offerType || [];
});
